import Swal from "sweetalert2";

const Toast = (
    icon = 'success',
    title,
    position = 'top',
    timer = 3000,
    timerProgressBar = true,
) => {
    Swal.mixin({
        toast: true,
        position,
        showConfirmButton: false,
        timer,
        timerProgressBar,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    }).fire({ icon, title})
}

export default Toast;